import { useTranslation } from 'react-i18next';
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, DatePicker, Flex, Form, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import { FormInstance } from "antd/lib";
import { FunctionComponent } from "react";
import SelectUiCard from "../../../../../../../components/select-ui";
import "./filter-group.scss";

type FormFilterProps = {
  showFilter?: boolean;
  clearFilter: (form: FormInstance) => void;
  onFinish?: any;
  optionSelectSchool: any;
  optionSelectAddress: any;
  setDataFilter: any;
  optionSelectYear: any;
  optionSelectFavorite: any;
  checkedList: any;
  dataFilter: any;
  optionSelectLevel: any;
};

const FormFilter: FunctionComponent<FormFilterProps> = ({
  showFilter,
  clearFilter,
  onFinish,
  optionSelectSchool,
  optionSelectAddress,
  setDataFilter,
  optionSelectYear,
  optionSelectFavorite,
  checkedList,
  dataFilter,
  optionSelectLevel
}) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const onChangeFilter = (val: string, name: string) => {
    setDataFilter({
      ...dataFilter,
      [name]: val
    });
  };

  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""} !pl-0`}>
        <Form
          name="formFilterMinistries"
          onFinish={onFinish}
          form={form}
          className="flex-wrap flex"
        >
          <Flex justify="end" className="w-full lg:w-4/5 pr-3">
            {checkedList.includes("year_of_birth") && (
              <SelectUiCard
                className="font-medium w-full lg:w-1/4 px-2"
                name="year"
                label=""
                filterOption={(input: any, option: any) =>
                  option?.label.toLowerCase().includes(input.toLowerCase())
                }
                options={optionSelectYear}
                mode="multiple"
                placeholder={t("Năm sinh", "Năm sinh")}
                allowClear
                onChange={(val) => onChangeFilter(val, "year")}
              />
            )}
            {checkedList.includes("university") && (
              <SelectUiCard
                className="font-medium w-full lg:w-1/4 px-2"
                name="university"
                label=""
                filterOption={(input: any, option: any) =>
                  option?.label.toLowerCase().includes(input.toLowerCase())
                }
                options={optionSelectSchool}
                mode="multiple"
                placeholder={t("Trường", "Trường")}
                allowClear
                onChange={(val) => onChangeFilter(val, "university")}
              />
            )}
            {checkedList.includes("address") && (
              <SelectUiCard
                className="font-medium w-full lg:w-1/4 pr-2"
                name="address"
                label=""
                filterOption={(input: any, option: any) =>
                  option?.label.toLowerCase().includes(input.toLowerCase())
                }
                options={optionSelectAddress}
                mode="multiple"
                placeholder={t("Địa chỉ", "Địa chỉ")}
                allowClear
                onChange={(val) => onChangeFilter(val, "address")}
              />
            )}
            {checkedList.includes("hobby") && (
              <SelectUiCard
                className="font-medium w-full lg:w-1/4 px-2"
                name="hobby"
                label=""
                filterOption={(input: any, option: any) =>
                  option?.label.toLowerCase().includes(input.toLowerCase())
                }
                options={optionSelectFavorite}
                mode="multiple"
                placeholder={t("Sở thích", "Sở thích")}
                allowClear
                onChange={(val) => onChangeFilter(val, "hobby")}
              />
            )}
            {checkedList.includes("academic_level") && (
              <SelectUiCard
                className="font-medium w-full lg:w-1/4 px-2"
                name="academic_level"
                label=""
                filterOption={(input: any, option: any) =>
                  option?.label.toLowerCase().includes(input.toLowerCase())
                }
                options={optionSelectLevel}
                mode="multiple"
                placeholder={t("Trình độ", "Trình độ")}
                allowClear
                onChange={(val) => onChangeFilter(val, "academic_level")}
              />
            )}
          </Flex>
          <Flex className="w-full lg:w-1/5">
            <Button
              className="btn btn-primary filter-btn mr-2 lg:mr-0"
              htmlType="submit"
            >
              <FilterOutlined />
              <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
            </Button>
            <Button
              className="btn btn-outlined clear-filter-btn"
              onClick={() => clearFilter(form)}
            >
              <DeleteOutlined />
              <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
            </Button>
          </Flex>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;
